import axios from '@axios'

const PREFIX = '/equipes'

export default {

  getEquipes(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getEquipe(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateEquipe(id, equipe, sobrescreveSN) {
    return axios.put(`${PREFIX}/${id}?sobrescreveSN=${sobrescreveSN}`, equipe)
  },

  createEquipe(equipe, sobrescreveSN) {
    return axios.post(`${PREFIX}/add?sobrescreveSN=${sobrescreveSN}`, equipe)
  },

  deleteEquipe(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getEquipesFiltradas(nome) {
    return axios.get(`${PREFIX}/filtro-equipes?nome=${nome}`)
  },

  verificaEquipeSNExistente(id) {
    return axios.get(`${PREFIX}/simples-nacional?id=${id}`)
  },

  listarDepartamentosOmie() {
    return axios.get(`${PREFIX}/departamentos-omie`)
  },
}
